import { hubService } from '@/services';
import { i18n } from '@/locales';
export default {
    async applyAddCharge({ commit }, payload = {}) {
        const { hubId = '', applyYn = 'N', reason = '', } = payload;
        await hubService.applyAddCharge({
            hubId,
            applyYn,
            reason,
        });
        commit('snackbar/SHOW_MESSAGE', {
            message: i18n.t('views.hub_configuration.changed_apply_add_charge'),
        }, {
            root: true,
        });
    },
    async addDeliveryCharge({ commit }, payload = {}) {
        const { hubId = '', charge = 0, chargeRate = 0, reason = '', } = payload;
        await hubService.addDeliveryCharge({
            hubId,
            charge,
            chargeRate,
            reason,
        });
        commit('snackbar/SHOW_MESSAGE', {
            message: i18n.t('views.hub_configuration.changed_add_delivery_charge'),
        }, {
            root: true,
        });
    },
    async updateWorkerBulletin({ commit }, payload = {}) {
        const { hubId = '', bulletin = '원활', } = payload;
        await hubService.updateWorkerBulletin({
            hubId,
            bulletin,
        });
        commit('snackbar/SHOW_MESSAGE', {
            message: i18n.t('views.hub_configuration.changed_worker_bulletin'),
        }, {
            root: true,
        });
    },
    async getWorkerDeliveryFeeGroup({ commit }, payload = {}) {
        const { hubId = '' } = payload;
        const response = await hubService.getWorkerDeliveryFeeGroup({
            hubId,
        });
        commit('SET_WORKER_DELIVERY_FEE_GROUP', response.data);
    },
    async getAgencyShareInfo({ commit, rootState }, payload = {}) {
        if (rootState?.user?.userInfo?.level && rootState.user.userInfo.level >= 70) {
            return;
        }
        const { hubId = '' } = payload;
        const { list } = await hubService.getAgencyShareInfo({
            hubId,
        });
        const agencyShareInfo = list
            .filter(({ shareDisplayYn }) => shareDisplayYn === 'Y');
        commit('SET_AGENCY_SHARE_INFO', agencyShareInfo);
    },
    async setAgencyShareInfo({ commit }, payload) {
        commit('SET_AGENCY_SHARE_INFO', payload);
    },
};
